const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const styles = require("./styles/StatsIcon.css");
const colors = require("../util/ColorUtil").getCurrentScheme();

module.exports = createReactClass({
	displayName: "StatsIcon",

	propTypes: {
		type: PT.oneOf([
			"star",
			"star1",
			"star2",
			"star3",
			"trophy",
			"xp",
			"time",
			"intervened",
			"quit",
			"jigsaw",
			"student",
			"teacher",
			"check",
			"moon",
			"comet",
			"planet",
			"galaxy",
			"bonus",
		]),
		style: PT.oneOf(["office", "trainer", "school"]),
		className: PT.string,
		color: PT.string,
		disabled: PT.bool,
		onClick: PT.func,
	},

	getInitialState: function() {
		return {
			isHovering: false,
		};
	},

	onHoverStart: function() {
		this.setState({isHovering: true});
	},

	onHoverEnd: function() {
		this.setState({isHovering: false});
	},

	render: function() {
		const defaultColor = colors.yellow; //default office icon color

		const color = this.props.color || defaultColor;
		const {type, className, disabled, style, onClick} = this.props;
		const {isHovering} = this.state;
		let svg;

		let mainClass = styles.main;
		if (className) mainClass += " " + className;

		const isOffice = style === "office" || style === "school";

		const mainStyle = {};

		if (disabled) {
			mainStyle.fill = colors.disabledIcon;
			if (isHovering && onClick) mainStyle.fill = colors.lightGrayBorder;
		} else if (type !== "intervened") {
			mainStyle.fill = color;
			if (isHovering && onClick) mainStyle.fill = colors.yellowHover;
		}

		if ((type === "intervened" || type === "quit") && onClick) {
			mainClass += " " + styles.clickableCircle;
		}

		if (type === "star" || type === "star1") {
			if (isOffice) {
				svg = (
					<svg
						className={styles.svg}
						version="1.1"
						x="0px"
						y="0px"
						viewBox="0 0 40 40"
						width="40"
						height="40"
						preserveAspectRatio="none"
					>
						<polygon points="19.92 1.91 24.62 15.44 38.94 15.73 27.53 24.38 31.67 38.09 19.92 29.91 8.16 38.09 12.31 24.38 0.9 15.73 15.21 15.44 19.92 1.91" />
					</svg>
				);
			} else {
				svg = (
					<svg
						className={styles.svg}
						version="1.1"
						x="0px"
						y="0px"
						viewBox="0 0 40 40"
						width="40"
						height="40"
						preserveAspectRatio="none"
					>
						<polygon points="14.8,13.8 21.3,2.5 25.6,14.6 38.6,15.4 28.6,25.7 31.1,37.5 20.2,30 8.6,36.6 10.6,22.9 1.4,13.6" />
					</svg>
				);
			}
		} else if (type === "star2") {
			svg = (
				<svg
					className={styles.svg}
					version="1.1"
					x="0px"
					y="0px"
					viewBox="0 0 40 40"
					width="40"
					height="40"
					preserveAspectRatio="none"
				>
					<polygon points="14.1,14 20,3.2 26.7,15.2 38.9,15.7 29.2,25.8 32.2,36.8 19.8,30.1 9.4,36.8 11.8,24.3 1.1,15.4" />
				</svg>
			);
		} else if (type === "star3") {
			svg = (
				<svg
					className={styles.svg}
					version="1.1"
					x="0px"
					y="0px"
					viewBox="0 0 40 40"
					width="40"
					height="40"
					preserveAspectRatio="none"
				>
					<polygon points="13.4,14.1 18.1,2.7 26.1,13.9 38.3,15 30.3,23.6 33.7,35 20.9,29.5 11.4,37.3 13.3,24.6 1.7,17" />
				</svg>
			);
		} else if (type === "trophy") {
			if (isOffice) {
				svg = (
					<svg
						className={styles.svg}
						version="1.1"
						x="0px"
						y="0px"
						viewBox="0 0 40 40"
						width="40"
						height="40"
						preserveAspectRatio="none"
					>
						<path d="M25.1,25.47c6.28-2.73,10.81-10.35,10.81-19.33H30c0-.81.05-1.64.05-2.47H10c0,.83,0,1.66.05,2.47h-6c0,9,4.53,16.6,10.81,19.33a8.42,8.42,0,0,0,3.25,3.11c-1.41,3.52-3.35,5.82-5.51,6.21H12v2.42H28V34.79h-.64c-2.16-.39-4.1-2.69-5.51-6.21A8.42,8.42,0,0,0,25.1,25.47ZM29.86,7.84H34c-.76,6.19-3.45,11.42-7.15,14.35A45.82,45.82,0,0,0,29.86,7.84ZM6,7.84h4.12a45.82,45.82,0,0,0,3,14.35C9.47,19.26,6.78,14,6,7.84Z" />
					</svg>
				);
			} else {
				svg = (
					<svg
						className={styles.svg}
						version="1.1"
						x="0px"
						y="0px"
						viewBox="0 0 40 40"
						width="40"
						height="40"
						preserveAspectRatio="none"
					>
						<path d="m38.4,4.75l-10,0.3c0.1,-1.1 0.2,-1.7 0.2,-1.7l-17.6,0c0,0 0,0.9 0.1,2.2l-9.5,0.3c0,0 1.1,12.5 13,15c0.5,0.8 1.1,1.5 1.8,2.1l-2.4,3.2l3.6,-0.1l0,1.8l-2.2,2.9l-2.6,0l-1.5,2.6l9.6,3.3l6.7,-3.7l-2.2,-2.3l-2.6,-0.2l-1.3,-2.3l-0.1,-2.2l3.5,-0.1l-2,-3.1c0.5,-0.6 1,-1.3 1.5,-2c12.5,-2.9 14,-16 14,-16zm-3.8,2.3c0,0 -1,7 -8.6,9.7c1.1,-3.2 1.7,-6.9 2.1,-9.5l6.5,-0.2zm-29.2,0.7l5.8,-0.2c0.2,2.6 0.6,6 1.6,9.1c-6.7,-2.6 -7.4,-8.9 -7.4,-8.9z" />
					</svg>
				);
			}
		} else if (type === "xp") {
			if (isOffice) {
				svg = (
					<svg
						className={styles.svg}
						version="1.1"
						x="0px"
						y="0px"
						viewBox="0 0 40 40"
						width="40"
						height="40"
						preserveAspectRatio="none"
					>
						<g>
							<path d="M15.34,30.49l-1.88-3.77c-.78-1.45-1.27-2.53-1.86-3.74h-.06c-.43,1.21-1,2.29-1.64,3.74L8.2,30.49H2.83L8.85,20,3,9.66H8.45l1.82,3.81c.62,1.26,1.08,2.28,1.58,3.46h.06c.49-1.33.9-2.26,1.42-3.46l1.76-3.81h5.38L14.6,19.83l6.18,10.66Z" />
							<path d="M23.32,9.94a39.42,39.42,0,0,1,6.37-.43c2.9,0,5,.56,6.36,1.67A6,6,0,0,1,38.27,16a6.46,6.46,0,0,1-1.91,4.94,9.79,9.79,0,0,1-6.77,2.2A7.43,7.43,0,0,1,28,23v7.48H23.32ZM28,19.4a7.16,7.16,0,0,0,1.57.12c2.5,0,4.05-1.26,4.05-3.37,0-1.91-1.33-3-3.71-3a8.56,8.56,0,0,0-1.91.15Z" />
						</g>
					</svg>
				);
			} else {
				svg = (
					<svg
						className={styles.svg}
						version="1.1"
						x="0px"
						y="0px"
						viewBox="0 0 40 40"
						width="40"
						height="40"
						preserveAspectRatio="none"
					>
						<g>
							<path
								id="svg_3"
								d="m3.5,26.8l1.5,-0.3l4.1,-6.6l-3.9,-6.5l-1.5,-0.3l-1.2,-2.7l8.5,-0.3l-0.5,3l-1.4,0.2l2.6,4.7l3,-4.7l-1.5,-0.2l-1.1,-3l8.5,0.2l-0.4,2.8l-1.5,0.3l-4.3,6.9l4.5,6.2l1.6,0.3l0.4,2.5l-8.1,0.1l0.6,-2.6l1.4,-0.1l-2.8,-3.8l-3,3.8l1.5,0.1l0.6,2.9l-8.3,0l0.7,-2.9z"
							/>
							<path
								id="svg_4"
								d="m32.4,10.7c2.1,0.1 2.8,0.9 3.9,2.1s1.2,2.5 1.1,4.2c-0.1,1.7 -0.3,3.1 -1.5,4.1c-1.2,1 -2.9,1.4 -5,1.3l-2.6,-0.1l-0.2,4l1.4,0.4l0.6,3.3l-8,-0.7l0.1,-2.9l1.9,-0.3l0.6,-12.9l-2.4,-0.2l0.7,-3l3.6,0.2l5.8,0.5zm-3.8,8.5l2.6,0.5c1,0 1.8,-0.2 2.3,-0.7s0.5,-1.3 0.5,-2.1c0,-0.9 0.2,-1.5 -0.3,-2.1c-0.5,-0.6 -1.2,-0.9 -2.2,-1l-2.6,-0.2l-0.3,5.6z"
							/>
						</g>
					</svg>
				);
			}
		} else if (type === "time") {
			if (isOffice) {
				svg = (
					<svg
						className={styles.svg}
						version="1.1"
						x="0px"
						y="0px"
						viewBox="0 0 40 40"
						width="40"
						height="40"
						preserveAspectRatio="none"
					>
						<g>
							<path d="M20.65,4.67A15.77,15.77,0,1,0,36.42,20.44,15.77,15.77,0,0,0,20.65,4.67Zm1,16.78v1.09h-2V21.45H18.57v-2h1.06V6.09h2V19.42H32v2Z" />
						</g>
					</svg>
				);
			} else {
				svg = (
					<svg
						className={styles.svg}
						version="1.1"
						x="0px"
						y="0px"
						viewBox="0 0 40 40"
						width="40"
						height="40"
						preserveAspectRatio="none"
					>
						<g>
							<path d="m32.3,9.75l-11.6,-5.7l-12.5,4.7l-4.3,10.5l4.2,12.3l12.2,4.4l11.7,-5.3l4.1,-11.4l-3.8,-9.5zm-12.2,23.4c-7.2,0 -13,-5.8 -13,-13c0,-8.5 5.8,-13 13,-13c7.2,0 12.7,5.8 13,13c0.4,8.6 -5.8,13 -13,13z" />
							<path d="m20.1,8.25c-6.5,0 -11.8,5.3 -11.8,11.8c0,6.5 5.3,12.5 11.8,11.8c8,-0.8 11.8,-5.3 11.8,-11.8c0,-6.5 -5.3,-11.8 -11.8,-11.8zm7.4,15.9l-8.4,-2.3l-3.1,-10.7l2.7,-1.1l2.2,10.8l7.2,1.7l-0.6,1.6z" />
						</g>
					</svg>
				);
			}
		} else if (type === "intervened" || type === "quit") {
			if (isOffice) {
				svg = (
					<svg
						className={styles.svg}
						version="1.1"
						x="0px"
						y="0px"
						viewBox="0 0 40 40"
						width="40"
						height="40"
						preserveAspectRatio="none"
					>
						<g transform="scale(0.7,0.7) translate(8,8)">
							<circle fill={colors.incorrectFill} cx="20.3" cy="34.5" r="4.7" />
							<polygon
								fill={colors.incorrectFill}
								points="23.8,27.1 16.8,27.1 14.3,1.1 26.1,1.1"
							/>
						</g>
					</svg>
				);
			} else {
				svg = (
					<svg
						className={styles.svg}
						version="1.1"
						x="0px"
						y="0px"
						viewBox="0 0 40 40"
						width="40"
						height="40"
						preserveAspectRatio="none"
					>
						<g id="Octagon">
							<path
								fill={colors.shadedFill}
								d="M33,7.5L20.6,2.1L6.3,8.6L1.4,19.9l5,14.2l14.5,3.4l14.5-7.2l3.2-12L33,7.5M20,20.6l0.6-18.5L6.3,8.6l0,0L20,20.6z"
							/>
						</g>
						<g id="Exclamation_point">
							<path
								fill={colors.incorrectFill}
								d="m20.2,32.37778c-1.8,0 -3.3,-1.5 -3.3,-3.3c0,-1.8 1.5,-3.3 3.3,-3.3c1.8,0 3.3,1.5 3.3,3.3c0,1.8 -1.5,3.3 -3.3,3.3z"
							/>
							<path
								fill={colors.incorrectFill}
								d="m23.1,22.87778l-5,0l-1.7,-13.9l8.1,-0.9l-1.4,14.8z"
							/>
						</g>
					</svg>
				);
			}
		} else if (type === "jigsaw") {
			svg = (
				<svg
					className={styles.svg}
					version="1.1"
					x="0px"
					y="0px"
					viewBox="0 0 40 40"
					width="40"
					height="40"
					preserveAspectRatio="none"
				>
					<g>
						<path d="M37.10831,18.20708A3.51734,3.51734,0,0,0,35.688,17.03081a3.63973,3.63973,0,0,0-3.6894.30127,2.13965,2.13965,0,0,0-.68383.895A1.657,1.657,0,0,1,29.713,19.36376,1.21454,1.21454,0,0,1,28.42062,18.309c-.17627-1.61151-.32159-3.23-.38226-4.84937-.0517-1.37909.0321-2.76324.05646-4.17181-.49793.03522-.99134.05047-1.47974.108-2.58545.30469-5.16968.62024-7.75439.93128a2.76856,2.76856,0,0,1-.33112.027,1.45673,1.45673,0,0,1-1.42712-.66784,1.4187,1.4187,0,0,1,.21-1.55683,2.3856,2.3856,0,0,1,.35156-.42657,3.16761,3.16761,0,0,0,.87219-3.249,3.2488,3.2488,0,0,0-3.12329-2.51837c-.16247-.01788-.32294-.05365-.48431-.08117q-.7739.05484-1.54767.10955a16.40006,16.40006,0,0,0-1.98847.91919A3.745,3.745,0,0,0,9.5787,6.44689,2.09293,2.09293,0,0,0,10.64718,8.218c.1576.09589.31916.18634.47059.29126.33947.23505.70263.48645.59246.96784a1.16855,1.16855,0,0,1-.98718.9989c-1.15283.13684-2.31085.259-3.47.30566-1.29028.05188-2.58417.0116-3.87646.01551-.18232.00055-.36463.02405-.60273.041-.01025.21564-.03827.42993-.02771.64227.1109,2.23121.2229,4.46241.34827,6.69281a5.72143,5.72143,0,0,0,.16913,1.09235,1.36285,1.36285,0,0,0,.269.53272,1.54638,1.54638,0,0,0,.68146.18505,1.72394,1.72394,0,0,0,1.82427-.85664,2.54908,2.54908,0,0,1,.77-.96253,3.2251,3.2251,0,0,1,3.46512-.1123,2.9217,2.9217,0,0,1,1.20317,1.17108,5.55034,5.55034,0,0,1,.25667,5.37415c-.714,1.62241-3.07174,2.99905-4.74849,1.23525a3.68679,3.68679,0,0,0-1.01066-.70586,1.62137,1.62137,0,0,0-2.33128.94c.09192,1.02313.20606,2.046.384,3.056.40026,2.27137.87835,4.52887,1.303,6.79609a.61263.61263,0,0,0,.6258.6,46.6476,46.6476,0,0,0,7.86473.388c.694-.06378,1.27094-.2586,1.49256-1.00036a1.7941,1.7941,0,0,0-.487-1.96991,2.78391,2.78391,0,0,1,.75781-4.22736,4.66955,4.66955,0,0,1,4.22443-.10858A2.23377,2.23377,0,0,1,20.421,33.2552a1.37832,1.37832,0,0,0,.20965,2.16107,2.82979,2.82979,0,0,0,1.5846.52417,17.64865,17.64865,0,0,0,3.08613-.605c1.66522-.29859,3.30176-.75739,4.99316-1.15625-.2489-1.2323-.51629-2.37641-.70428-3.53345-.22473-1.38287-.45484-2.77191-.549-4.1673-.113-1.67358.82269-2.29419,2.39325-1.67413a2.351,2.351,0,0,1,.82837.52691,3.22633,3.22633,0,0,0,5.41961-1.05377A6.18349,6.18349,0,0,0,37.10831,18.20708Z" />
					</g>
				</svg>
			);
		} else if (type === "student") {
			svg = (
				<svg
					className={styles.svg}
					version="1.1"
					x="0px"
					y="0px"
					viewBox="0 0 40 40"
					width="40"
					height="40"
					preserveAspectRatio="none"
				>
					<g>
						<ellipse cx="20" cy="12.03" rx="6.44" ry="7.21" />
						<path d="M28,34c1.48-.1,2.86-.23,4.14-.38,0-6.15-1.34-11.33-7.4-13,.06-.36.11-.59.11-.59l-1.46-.37c-.06.22-.1.43-.15.64A20.19,20.19,0,0,0,20,20a19.2,19.2,0,0,0-3.17.24c0-.21-.09-.41-.14-.63L15.22,20s0,.22.11.57c-6.13,1.66-7.47,6.85-7.49,13,1.28.15,2.66.28,4.14.38a38.88,38.88,0,0,0,.85-6.29h.73c0,1.34-.13,2.58-.26,3.76-.11.11-.21.22-.32.32l-.4,1.69a3.67,3.67,0,0,0,.47-.21l-.12.79c2.14.12,4.49.19,7.07.19s4.93-.07,7.07-.19c-.05-.27-.09-.56-.13-.84a5.51,5.51,0,0,0,.57.26l-.39-1.69a5.7,5.7,0,0,1-.43-.42c-.13-1.15-.22-2.36-.25-3.66h.73A38.88,38.88,0,0,0,28,34Z" />
						<path
							fill={colors.white}
							d="M27.85,33.83l-.42-.14c-.07,0-7.21-2.45-4.26-14.12l.48.13c-2.43,9.64,2,12.64,3.5,13.34l-.26-1.13c-4-3.41-2.34-11.61-2.27-12l.49.1c0,.09-1.72,8.35,2.16,11.53l.07.05Z"
						/>
						<path
							fill={colors.white}
							d="M12.24,33.83l.51-2.2.07-.05C16.7,28.4,15,20.14,15,20.05l.49-.1c.07.35,1.76,8.55-2.27,12L12.94,33c1.46-.7,5.94-3.7,3.5-13.34l.49-.13c2.94,11.67-4.2,14.1-4.27,14.12Z"
						/>
					</g>
				</svg>
			);
		} else if (type === "teacher") {
			svg = (
				<svg
					className={styles.svg}
					version="1.1"
					x="0px"
					y="0px"
					viewBox="0 0 30 30"
					width="30"
					height="30"
					preserveAspectRatio="none"
				>
					<g>
						<path d="M25.22149,25.80659c.34132-.07787.52987-.14234.52987-.14234s-.52854-.06981-1.28925-.231c.169-.5631.56757-1.96752.35491-2.01884-.206-.04975-1.14545,1.17178-1.55914,1.72586q-.21128-.05844-.42777-.124c.17025-.48262.45761-1.3708.27981-1.40635-.1598-.03195-.79955.62481-1.22406,1.08415a5.9158,5.9158,0,0,1-2.49359-1.57336,7.92363,7.92363,0,0,1-1.25047-3.42943,4.463,4.463,0,0,0,.90112-.84141c.09573.28944.22543.52208.39527.52208.44968,0,1.27672-1.21805,1.60419-2.89174a5.03129,5.03129,0,0,0-.255-2.89882l.93718,1.12792a6.24473,6.24473,0,0,0,.19167-.78689,4.46248,4.46248,0,0,1,.2988,1.28432,8.60082,8.60082,0,0,1-1.07335,3.61717s-1.08015.69188-1.24928,1.37124c-.169.67967-.03143.90053.23379.97727s1.53669-1.69558,1.53669-1.69558a4.10356,4.10356,0,0,0-.06183,1.91133c.44542.863,1.56057,1.54948,2.02006,1.14413.4595-.40563-.55444-.91615-.55444-.91615s2.4834.583,2.61631-.09352-1.53357-.86471-1.53357-.86471,1.43962-1.02218,1.03255-1.35277c-.40691-.33059-1.94672.76692-1.94672.76692s1.36371-3.34285.59736-5.63707a6.45117,6.45117,0,0,0-1.93642-2.75523,4.50572,4.50572,0,0,0-1.23936-2.11265c.21022.18515,1.24386,1.06619,1.49185.71375.78993-1.12246-1.40756-2.77564-2.60679-3.56138.08935-.06367.18184-.13411.2768-.21316l1.64337.38453s.29737-.49575-.87737-1.20808c.05978-.08412.11825-.1711.1737-.26353.03022-.05037.05807-.10123.08484-.15228l.02149-.042q.03163-.06263.06005-.12565l.01411-.03083q.03347-.07651.06229-.15331l.01335-.03693q.02234-.06147.042-.12289l.01319-.04153c.01557-.051.03012-.10187.04305-.15252l.0041-.01723c.01145-.04581.02172-.09137.03113-.13671l.00847-.04211q.01274-.06533.023-.12974l.00352-.02116c.00755-.0499.01379-.09917.01914-.148l.0033-.03285q.00614-.061.01018-.12059l.00194-.028q.00433-.07248.0059-.14252l.00009-.00931c.00081-.044.00071-.08709,0-.12939L21.223,3.5818c-.00217-.09135-.00767-.17814-.01594-.25946L21.2062,3.314c-.04265-.40877-.1523-.67546-.22948-.66-.18192.03638-.40023.83685-1.05516,1.52816a3.4962,3.4962,0,0,1-2.09018.727,4.033,4.033,0,0,0-.47338.01409l1.96776-.89938A2.50178,2.50178,0,0,0,16.852,3.51759a4.07565,4.07565,0,0,0-1.50037.67615A25.54627,25.54627,0,0,0,14.23843.762a32.38746,32.38746,0,0,0-.65525,3.58052c-.81439-.53322-1.916-1.116-2.3533-.71236-.29547.27271-.12213.62814.189.95488a1.85745,1.85745,0,0,1-.60066-.40287C10.16334,3.49087,9.945,2.6904,9.76311,2.654c-.07713-.01543-.18668.25094-.22939.6593l-.001.00949c-.00822.081-.01371.16748-.01588.25847l-.00044.02315c-.00072.04171-.00083.08417,0,.12759l.00011.01069q.00147.06951.00586.14164l.002.02946q.004.05874.01.11884l.00344.03422c.00534.04862.01157.09771.01908.14743l.00355.02139q.01011.06417.02288.1293l.00853.04245c.00937.04508.01957.09035.03094.13589l.00432.01814c.01292.05057.02744.10137.043.15228l.01328.04183q.0195.061.04169.122l.01364.03773q.02889.07658.06215.15294l.01431.03127q.0283.06285.05986.12528l.02162.04227c.02674.051.05457.10182.08476.15214a4.11622,4.11622,0,0,0,.31075.44706,3.83154,3.83154,0,0,0-1.47975.68742A2.9093,2.9093,0,0,0,7.74419,8.35279l2.48511-.66318a5.58931,5.58931,0,0,0-1.649,1.93152c-.81056,1.56314-.56525,2.21436-.56525,2.21436l.30706-.13279c-.02454.05761-.04861.1169-.07155.18a3.2306,3.2306,0,0,0-.17932.81749,5.79557,5.79557,0,0,0-1.5808,2.16151c-.891,2.21748.28028,5.6888.28028,5.6888s-1.472-1.24531-1.89569-.95453.95267,1.45113.95267,1.45113-1.66985.02672-1.57521.7152c.09467.68875,2.6.34679,2.6.34679s-1.0381.41188-.60333.86129c.43492.44941,1.50485.01194,2.1558-.8738.48067-.65436-.03525-1.98865-.03525-1.98865S9.53656,22.00132,9.805,21.95016c.26834-.05088.41771-.25811.28738-.9534-.13061-.695-1.16757-1.49062-1.16757-1.49062a8.91586,8.91586,0,0,1-.86671-3.71723,4.19584,4.19584,0,0,1,.3202-1.14148,3.40369,3.40369,0,0,0,.15494.34472l.42905-.88338c-.05971.33563-.11038.68064-.14522,1.02521-.32747,3.23824,1.96591,4.0245,1.96591,4.0245l-.03855-.7371a4.04575,4.04575,0,0,0,1.93268,1.57023c-.08319.98846-.16772,2.14277-.18519,2.9287a20.48173,20.48173,0,0,0,.11268,2.5258c-4.64756.15329-7.896.69435-7.896,1.58085,0,1.06,4.64033,2.2118,10.76561,2.2118s9.87547-2.20725,10.04988-3.25246C25.535,25.92087,25.42944,25.86105,25.22149,25.80659Zm-8.47162-.40275c.01958-.18933.04034-.41551.05864-.66958a14.34052,14.34052,0,0,0,1.73074.68527Q17.68609,25.40831,16.74987,25.40384Zm-3.71213-2.73822a13.06113,13.06113,0,0,1,.01044-1.84132,7.65062,7.65062,0,0,0,3.00474,3.51892c-.07942.36382-.16933.72166-.26117,1.05784-.1057-.00012-.2105-.00032-.31752-.00032q-.98342,0-1.9106.01978A15.10539,15.10539,0,0,1,13.03774,22.66562Z" />
					</g>
				</svg>
			);
		} else if (type === "check") {
			svg = (
				<svg
					className={styles.svg}
					version="1.1"
					x="0px"
					y="0px"
					viewBox="0 0 40 40"
					width="40"
					height="40"
					preserveAspectRatio="none"
				>
					<g id="Header_Buttons" data-name="Header Buttons">
						<path d="M20.65018,4.66857a15.76907,15.76907,0,1,0,15.769,15.769A15.76907,15.76907,0,0,0,20.65018,4.66857Zm.3742,22.87286L17.07681,31.489l-3.94757-3.94757-5.1438-5.1438L11.933,18.45006l5.1438,5.1438L29.36722,11.30345,33.31473,15.251Z" />
					</g>
				</svg>
			);
		} else if (type === "moon") {
			svg = (
				<svg
					className={styles.svg}
					version="1.1"
					x="0px"
					y="0px"
					viewBox="0 0 48 48"
					width="48"
					height="48"
					preserveAspectRatio="none"
				>
					<g>
						<path
							d="M33.3,8.5c-0.9-0.7-1.8-1.3-2.8-1.8c2.7,3.2,4.3,7.3,4.3,11.8c0,10.2-8.2,18.4-18.4,18.4
		c-1.5,0-3-0.2-4.5-0.5c-1.5-0.4-2.9-0.9-4.2-1.6c2.5,2.9,5.8,5.1,9.6,6c1.4,0.4,2.9,0.5,4.5,0.5c10.2,0,18.4-8.2,18.4-18.4
		C40.3,17.1,37.5,11.9,33.3,8.5z"
						/>
					</g>
				</svg>
			);
		} else if (type === "comet") {
			svg = (
				<svg
					className={styles.svg}
					version="1.1"
					x="0px"
					y="0px"
					viewBox="0 0 48 48"
					width="48"
					height="48"
					preserveAspectRatio="none"
				>
					<g>
						<path
							d="M34.1,4c-4.4,0.5-7.6,1.6-11.5,4.3C9.6,17.2,6.5,26.7,6.5,26.7c3.5-2.7,6-3.9,9.5-4.5
		C5.5,30,1.7,44.1,1.7,44.1c6.8-8.5,18.7-14,18.7-14c-0.9,2.4-2.1,3.9-3.9,5.1c5.7-1.4,14.4-4.1,20.8-8c6.8-4.1,9-9,9-13.1
		C46.3,9.6,41.8,3,34.1,4z M31.8,24.2c-0.7-0.2-1.5-0.3-2.2-0.6c-1.5-0.5-2.8-1.7-3.6-3.1c-0.8-1.4-1.1-3.1-0.9-4.6
		c0.1-1.6,0.6-3.1,1.4-4.4c-0.3,1.5-0.4,3-0.3,4.4c0.1,1.4,0.4,2.8,1,4c0.1,0.3,0.3,0.6,0.6,0.8c0.2,0.3,0.4,0.5,0.7,0.8l0.8,0.7
		c0.3,0.2,0.6,0.4,0.9,0.6c0.6,0.4,1.3,0.6,1.9,0.9c0.7,0.2,1.4,0.5,2.1,0.7C33.4,24.3,32.6,24.3,31.8,24.2z"
						/>
					</g>
				</svg>
			);
		} else if (type === "planet") {
			svg = (
				<svg
					className={styles.svg}
					version="1.1"
					x="0px"
					y="0px"
					viewBox="0 0 48 48"
					width="48"
					height="48"
					preserveAspectRatio="none"
				>
					<g>
						<path d="M35.7,23.6c0,0.3,0.1,0.6,0.1,0.9C35.7,24.2,35.7,23.9,35.7,23.6z" />
						<path d="M35.7,24.7c0,0.2,0,0.4,0,0.6c0,0,0,0,0,0C35.7,25.2,35.7,24.9,35.7,24.7z" />
						<path d="M17.1,15.8c-0.1,0.1-0.3,0.2-0.4,0.3c0,0,0,0,0,0C16.8,16,16.9,15.9,17.1,15.8z" />
						<path d="M35.6,22.8C35.6,22.8,35.6,22.8,35.6,22.8c0,0.2,0.1,0.4,0.1,0.6C35.6,23.1,35.6,22.9,35.6,22.8z" />
						<path d="M18.8,14.7C18.8,14.7,18.8,14.7,18.8,14.7C18.8,14.7,18.8,14.7,18.8,14.7C18.8,14.7,18.8,14.7,18.8,14.7z" />
						<path d="M30.7,34.1C30.7,34.1,30.7,34.1,30.7,34.1c-0.1,0-0.2-0.1-0.3-0.1C30.5,34,30.6,34.1,30.7,34.1z" />
						<path
							d="M12.9,27c1,4.8,5.1,8.5,10.3,9c2.2,0.2,4.3-0.2,6.2-1.2c-1.5-0.5-5.6-1.9-8.9-3.4
			C17.2,29.9,14.6,28.3,12.9,27z"
						/>
						<path d="M25.6,27.6c-0.3-0.1-0.5-0.2-0.8-0.3C25,27.3,25.3,27.4,25.6,27.6z" />
						<path d="M13.3,20.9c0.3,0.2,0.7,0.4,1,0.7C14,21.3,13.6,21.1,13.3,20.9C13.3,20.9,13.3,20.9,13.3,20.9z" />
						<path
							d="M17.1,15.8c-0.1,0.1-0.3,0.2-0.4,0.3c-1.2,1-2.2,2.2-2.9,3.7c2.1,1.4,11.3,7.3,20.8,9.8
			c0.6-1.2,0.9-2.4,1.1-3.7c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.2c0-0.2,0-0.4,0-0.6c0-0.1,0-0.1,0-0.2c0-0.3,0-0.6-0.1-0.9
			c0-0.1,0-0.2,0-0.3c0-0.2-0.1-0.4-0.1-0.6c-0.9-4.9-5-8.9-10.4-9.3c-2.3-0.2-4.5,0.3-6.4,1.2c0,0,0,0-0.1,0
			C18.3,14.9,17.7,15.3,17.1,15.8z"
						/>
						<path
							d="M35.9,30.6c-10.7-2.8-21.1-9.5-23.5-11.1c0.7-1.5,1.7-2.8,2.9-3.8c-0.5-0.2-1.1-0.3-1.6-0.4c0,0,0,0-0.1,0
			c-1.2-0.3-2.1-0.4-2.9-0.5c-1.7-0.2-2.6,0.1-2.7,0.5c-0.3,0.6,0.5,2,3.6,4.4c0.5,0.4,1.1,0.8,1.7,1.2c0.3,0.2,0.7,0.4,1,0.7
			c3.5,2.4,7.2,4.2,10.5,5.6c0.3,0.1,0.5,0.2,0.8,0.3c0,0,0.1,0,0.1,0c3.2,1.4,6.1,2.4,8.4,3c4,1.1,6.5,1.1,6.8,0.3
			c0.2-0.5-0.3-1.4-1.5-2.6c-0.6-0.6-1.4-1.3-2.3-2c0,0,0,0,0,0C37,27.9,36.5,29.3,35.9,30.6z"
						/>
						<path
							d="M37.1,26.4c-0.1,1.5-0.6,2.9-1.2,4.2c-10.7-2.8-21.1-9.5-23.5-11.1c0.7-1.5,1.7-2.8,2.9-3.8
			c-0.5-0.2-1.1-0.3-1.6-0.4c0,0,0,0-0.1,0c-1.2-0.3-2.1-0.4-2.9-0.5c-1.7-0.2-2.6,0.1-2.7,0.5c-0.3,0.6,0.5,2,3.6,4.4
			c0.5,0.4,1.1,0.8,1.7,1.2c0.3,0.2,0.7,0.4,1,0.7c3.5,2.4,7.2,4.2,10.5,5.6c0.3,0.1,0.5,0.2,0.8,0.3c0,0,0.1,0,0.1,0
			c3.2,1.4,6.1,2.4,8.4,3c4,1.1,6.5,1.1,6.8,0.3c0.2-0.5-0.3-1.4-1.5-2.6C38.8,27.8,38.1,27.1,37.1,26.4L37.1,26.4
			C37.1,26.4,37.1,26.4,37.1,26.4z"
						/>
						<path
							d="M41.1,26.8c-0.1-0.1-0.3-0.2-0.4-0.4c-1.1-0.9-2.3-1.8-3.6-2.7l0,0c0,0,0,0.1,0,0.1c0,0.3,0.1,0.7,0.1,1
			c0,0.1,0,0.1,0,0.2c0,0.2,0,0.5,0,0.7c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.2c1,0.7,1.7,1.4,2.3,2c1.2,1.2,1.7,2.1,1.5,2.6
			c-0.4,0.8-2.9,0.7-6.8-0.3c-2.3-0.6-5.2-1.6-8.4-3c0,0-0.1,0-0.1,0c-0.3-0.1-0.5-0.2-0.8-0.3c-3.3-1.4-6.9-3.3-10.5-5.6
			c-0.3-0.2-0.7-0.4-1-0.7c-0.6-0.4-1.2-0.8-1.7-1.2c-3.1-2.4-3.8-3.8-3.6-4.4c0.2-0.4,1-0.7,2.7-0.5c0.8,0.1,1.7,0.2,2.9,0.5
			c0,0,0,0,0.1,0c0.5,0.1,1,0.3,1.6,0.4l0,0c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.3-0.2,0.5-0.4c0.5-0.3,0.9-0.6,1.3-0.9l0,0
			c-0.9-0.3-1.9-0.6-2.8-0.8C8.6,11.7,3.1,11.1,2,13.4c-1.3,2.8,3.8,7.7,10.7,12.1c1.2,0.8,2.5,1.6,3.8,2.3c3,1.6,7.5,3.7,13.9,6.1
			c0.1,0,0.2,0.1,0.3,0.1c2.2,0.7,4.3,1.3,6.2,1.6c0.8,0.1,1.6,0.3,2.5,0.3c2.7,0.2,5.9,0.1,6.7-1.6l0,0
			C47.1,32.2,43.7,29,41.1,26.8z"
						/>
					</g>
				</svg>
			);
		} else if (type === "galaxy") {
			svg = (
				<svg
					className={styles.svg}
					version="1.1"
					x="0px"
					y="0px"
					viewBox="0 0 48 48"
					width="48"
					height="48"
					preserveAspectRatio="none"
				>
					<g>
						<path
							d="M13.3,16.3c7.8-3.8,16.6-4.3,21.3-2.4c2.8,1.1,4.3,5.5-1.9,9.5c-6.6,4.3-12,3.2-12.7,1.3
		c-0.5-1.3,1-3.8,3.7-4.9c2-0.8,3.7-0.5,3.9-0.5c-0.8-0.5-3.2-0.7-5.5,0c-3.7,1.2-6.4,3.1-6.2,6.5c0.3,3.4,7.5,3.9,13.8,1.6
		c6.3-2.3,9.8-6,10.5-9.4c0.8-3.7-3.1-5.7-5.8-6.4c-7.8-2-19.1,1.6-19.1,1.6c-0.2-0.2,13.9-7.4,25-1.9c4,2,9.4,10.6-6.7,18.4
		c-4.3,2.1-12,4.5-17.3,2.5c-5.3-2-6-6.1-2.9-10.2c2.8-3.5,9.5-6.2,14.8-4.9c3.9,0.9,2.2,3.9,0.4,4.7c-2.8,1.3-4.2-0.3-4.2-0.3
		s-1.7,1.9-0.2,2.5c1.6,0.6,4.8-0.6,6.5-1.7c1.7-1.1,3.7-3.7,2.6-5.7c-1-1.9-5.1-2.2-10.2-1.4c-5.6,0.9-12.2,3.9-14.8,8.2
		c-1.4,2.3-2.9,11.1,7.5,12.1c15.3,1.5,28.1-7.4,28.1-7.4s-16,14.3-31.7,9.7C-3.6,33.2,5.2,20.1,13.3,16.3z"
						/>
					</g>
				</svg>
			);
		} else if (type === "bonus") {
			svg = (
				<svg
					className={styles.svg}
					version="1.1"
					x="0px"
					y="0px"
					viewBox="0 0 40 40"
					width="40"
					height="40"
					preserveAspectRatio="none"
				>
					<g>
						<path d="M35,21.65l-.57-.55a2.23,2.23,0,0,0,.15-.63,3.23,3.23,0,0,0-1.83-2.83c1.49-.32,1.95-1.26,1.74-2.18A10.75,10.75,0,0,0,37.8,7.72,6.6,6.6,0,0,1,33,11a1.14,1.14,0,0,0-.16-.31,3.3,3.3,0,0,0-2.74-1,1.9,1.9,0,0,0,.46-3.11,3.87,3.87,0,0,0-3.84,0c1-3.19-4.27-4.34-5-1.37C21,3.66,19.82,2.56,18,2.84,16,3.2,15.61,4.42,15.8,6.4c-1.5-3.17-6.67-.09-4.11,1.92A2.9,2.9,0,0,0,8.21,9.51a1.89,1.89,0,0,0,.22,2A7.17,7.17,0,0,1,1.5,8.06s-.21,6.23,5.41,9.13c-1.28.74-1.63,2.69-.55,3.53-.31.27-.64.57-1,.93-3.06,3.07-3.55,9.57-3.55,9.57l1.32-1.64,1.28,3.35L5,30.87l1.72,1.86V29.66L8,30.18l-.56-2.59L8.7,25.72a2.56,2.56,0,0,0,1-.33c.06.21.12.4.19.58,0,1.86,1.42,3.21,2.8,2.58l.56,5.65c-.81-.15-3.87-.7-3.32-.06a3,3,0,0,0,1.06.62c-.86.14-1.63.34-1.63.58,0,.54,2.85.24,2.85.24S10,36.82,11,37.16s3.79-1.41,3.79-1.41l4.21,0,.31-5.65a3,3,0,0,0,1.72.43l.27,4.89,4.21,0s2.83,1.76,3.79,1.42S28,35.26,28,35.26s2.84.3,2.85-.24c0-.25-.77-.44-1.63-.59a2.84,2.84,0,0,0,1.06-.61c.55-.64-2.51-.09-3.32.06l.55-5.53a2.08,2.08,0,0,0,2.2-.2A2.33,2.33,0,0,0,30.28,26c.07-.17.14-.36.21-.56a1.74,1.74,0,0,0,1,0l1.44,2.08-.57,2.59,1.3-.52v3.07l1.73-1.86.53,2.06,1.27-3.35,1.33,1.64S38,24.72,35,21.65Z" />
					</g>
				</svg>
			);
		}

		if (onClick) {
			mainClass += " " + styles.clickable;
		}

		return (
			<div
				className={mainClass}
				style={mainStyle}
				onClick={onClick}
				onMouseEnter={this.onHoverStart}
				onMouseLeave={this.onHoverEnd}
			>
				{svg}
			</div>
		);
	},
});
